import { Pipe, PipeTransform } from '@angular/core';

/** Returns the substring before the first line break (\r\n, \n, or \r). */
@Pipe({
  name: 'firstLine',
  standalone: true,
})
export class FirstLinePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const [first] = value.split(/\r\n|\r|\n/, 1);
    return first.trimEnd();
  }
}
